import { UserMenuService } from '@abp/ng.theme.shared';
import { APP_INITIALIZER } from '@angular/core';

/**
 * Entries the ABP modules add to the profile dropdown that SitePlant does not offer. The ids are the
 * ones the modules register them under: the first five come from LeptonX's user-menu provider
 * (eUserMenuItems), the last from the GDPR module. Logout and Back to impersonator stay.
 */
const REMOVED_USER_MENU_ITEMS = [
  'ExternalLogins',
  'LinkedAccounts',
  'AuthorityDelegation',
  'MyAccount',
  'SecurityLogs',
  'Gdpr.GdprNavigation',
];

export const USER_MENU_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureUserMenu,
    deps: [UserMenuService],
    multi: true,
  },
];

function configureUserMenu(userMenu: UserMenuService) {
  return () => {
    REMOVED_USER_MENU_ITEMS.forEach(id => userMenu.removeItem(id));
  };
}
